// Angular
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgIf, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
// Environment
import { environment } from '@environment';
// Transloco
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
// App Version
import packageInfo from '@packageInfo';
// RxJS
import { Observable } from 'rxjs';
// Pipes
import { MakeMePrettyPipe } from '@app/core/_base/layout';

@Component({
  selector: 'app-footer',
  templateUrl: `./${environment.orgId}-footer.component.html`,
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, RouterLink, AsyncPipe, MakeMePrettyPipe],
})
export class FooterComponent implements OnInit {
  // Private
  private readonly translocoService = inject(TranslocoService);

  // Public
  currentDateStr: string = new Date().getFullYear().toString();
  appVersion = packageInfo.version;
  languageChange$: Observable<string>;

  ngOnInit(): void {
    // Get Current live language
    this.languageChange$ = this.translocoService.langChanges$;
  }
}
